import React, { PropsWithChildren } from "react";
import styles from "./index.scss";

const TitleSpan: React.FC<PropsWithChildren> = ({ children }) => {
	return (
		<React.Fragment>
			<span className={styles.spanText + " " + styles.spanWidth}>{children}</span>
		</React.Fragment>
	);
};

export default TitleSpan;
